const skills = {
  1: [
    {
      title: "HTML",
      level: 6,
    },
    {
      title: "CSS",
      level: 5,
    },
    {
      title: "JavaScript",
      level: 3,
    },
    {
      title: "Boostrap 5",
      level: 2,
    },
    {
      title: "React JS",
      level: 4,
    },
    {
      title: "Figma",
      level: 5,
    },
  ],
  2: [
    {
      title: "Node.js",
      level: 2,
    },
    {
      title: "MongoDB",
      level: 2,
    },
    {
      title: "Git",
      level: 4,
    },
    {
      title: "SQL",
      level: 3,
    },
  ],
};

export default skills;
